import { render, staticRenderFns } from "./renjie.vue?vue&type=template&id=60b7f449&scoped=true&"
import script from "./renjie.vue?vue&type=script&lang=js&"
export * from "./renjie.vue?vue&type=script&lang=js&"
import style0 from "./renjie.vue?vue&type=style&index=0&id=60b7f449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7f449",
  null
  
)

export default component.exports